import * as React from 'react';
import { useContext } from 'react';
import { Search, SearchProps } from './components/Search';
import { useQueryParams } from '../../hooks/useQueryParams';
import { SearchContext } from '../SearchContext';
import { Cell } from './components/Cell';
import { BoardingType } from '../../types/BoardingType';
import { Gender } from '../../types/Gender';
import { Age } from '../../types/Age';
import { Field } from './components/Field';
import { Picker } from './components/Picker';
import { Radio } from './components/Radio';

interface Data {
    q: string;
    boarding_type: BoardingType;
    gender: Gender;
    ages: Age[];
    countries: string[];
    curricula: string[];
}

export const InternationalSchoolSearch: React.FC<SearchProps> = ({ container, type }) => {
    const {
        qsOverride,
        countries,
        curricula,
        ages,
        boarding_type,
        gender,
    } = useContext(SearchContext);
    const params = useQueryParams(qsOverride);

    const fields: Data = {
        q: params.getQuery(),
        boarding_type: params.getBoardingType(),
        gender: params.getGender(),
        ages: params.getAges(),
        countries: params.getCountries(),
        curricula: params.getCurricula(),
    };

    return (
        <Search container={container} type={type} data={fields}>
            <Cell width="50">
                <Field<Data, 'q'> name="q">
                    {(value, setValue) => (
                        <input
                            className="field"
                            type="text"
                            placeholder="Search by school name or location..."
                            value={value}
                            onChange={e => setValue(e.target.value)}
                        />
                    )}
                </Field>
            </Cell>

            <Cell width="50">
                <Field<Data, 'curricula'> name="curricula">
                    {(value, setValue) => (
                        <Picker
                            label="Curricula"
                            all={{ value: 'all', label: 'All' }}
                            selected={value}
                            onChange={setValue}
                            options={curricula}
                        />
                    )}
                </Field>
            </Cell>

            <Cell width="50">
                <Field<Data, 'countries'> name="countries">
                    {(value, setValue) => (
                        <Picker
                            label="Countries"
                            all={{ value: 'all', label: 'All' }}
                            selected={value}
                            onChange={setValue}
                            options={countries}
                        />
                    )}
                </Field>
            </Cell>

            <Cell width="50">
                <Field<Data, 'ages'> name="ages">
                    {(value, setValue) => (
                        <Picker
                            label="Ages"
                            selected={value}
                            onChange={setValue}
                            options={ages}
                        />
                    )}
                </Field>
            </Cell>

            <Cell width="50">
                <Field<Data, 'boarding_type'> name="boarding_type">
                    {(value, setValue) => (
                        <Radio
                            value={value}
                            onChange={setValue}
                            options={boarding_type}
                        />
                    )}
                </Field>
            </Cell>

            <Cell width="50">
                <Field<Data, 'gender'> name="gender">
                    {(value, setValue) => (
                        <Radio
                            value={value}
                            onChange={setValue}
                            options={gender}
                        />
                    )}
                </Field>
            </Cell>
        </Search>
    );
};
